
const validate = (values) => {
  const errors = {};

  if (!values.locationName || values.locationName.trim() === '') {
    errors.locationName = 'Please enter location name';
  }
  if (!values.facilityName || values.facilityName.trim() === '') {
    errors.facilityName = 'Please enter facility name';
  }  
  if (!values.facilityCode) {
    errors.facilityCode = 'Please select facility code';
  }
  
  if (!values.facilityNPINumber) {
    errors.facilityNPINumber = 'Please enter facility NPI number';
  } else if ((values.facilityNPINumber || '').length < 10) {
    errors.facilityNPINumber = 'Please enter valid NPI number (upto 10 digits)';
  }

  // if (!values.FacilityProviderNumber) {
  //   errors.FacilityProviderNumber = 'Please add facility provider number';
  // }
  // if (values.FacilityProviderNumber && values.FacilityProviderNumber.length < 10) {
  //   errors.FacilityProviderNumber = 'Incorrect facility provider number';
  // }
  if (!values.billingTaxId) {
    errors.billingTaxId = 'Please enter billing tax id';
  } else if (values.billingTaxId && values.billingTaxId.length < 9) {
    errors.billingTaxId = 'Please enter valid billing tax id (upto 9 digits)';
  }
  // if (!values.BillingNPINumber) {
  //   errors.BillingNPINumber = 'Please add billing NPI number';
  // }
  if (values.billingNPINumber && values.billingNPINumber.length < 10) {
    errors.billingNPINumber = 'Please enter valid NPI number';
  }
  if (!values.Address || values.Address.trim() === '') {
    errors.Address = 'Please enter address';
  }
  if (!values.city || values.city.trim() === '') {
    errors.city = 'Please enter city';
  }
  if (!values.stateID) {
    errors.stateID = 'Please select state';
  } else if (!Number.isInteger(values.stateID)) {
    errors.stateID = 'Please select an option';
  }
  if (!values.countryID) {
    errors.countryID = 'Please select country';
  } else if (!Number.isInteger(values.countryID)) {
    errors.countryID = 'Please select an option';
  }
  if (!values.zip || values.zip.trim() === '') {
    errors.zip = 'Please enter zip code';
  } else if (values.zip && values.zip.length < 5) {
    errors.zip = 'Please enter correct zip code';
  }
  if (!values.phone) {
    errors.phone = 'Please enter phone number';
  } else if (values.phone.length < 14) {
    errors.phone = 'Please enter valid phone number';
  }

  // if (!values.mileageRate) {
  //   errors.mileageRate = 'Please enter mileage rate';
  // }
  if (values.officeEndHour && values.officeStartHour) {
    if (Date.parse(values.officeStartHour) >= Date.parse(values.officeEndHour)) {
      errors.officeStartHour = 'Invalid start time';
    }
    if (Date.parse(values.officeEndHour) <= Date.parse(values.officeStartHour)) {
      errors.officeEndHour = 'Invalid end time';
    }
  }
  
  // if (!values.timeZoneId) {
  //   errors.timeZoneId = 'Please select time zone';
  // } else if (!Number.isInteger(values.timeZoneId)) {
  //   errors.timeZoneId = 'Please select an option';
  // }
  if (!values.taxonomyCodeIds || values.taxonomyCodeIds === undefined) {
    errors.taxonomyCodeIds = 'Please select taxonomy code';
  }
  
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/location-master/validate.js